const Dataex=
    [
        {
            id:1,
            title:"Fjallraven - Foldsack No. 1 Backpack, Fits 15 Laptops",
            price:120,
            description:"Your perfect pack for everyday use and walks in the forest. Stash your laptop (up to 15 inches) in the padded sleeve, your everyday",
            category:"men",
            image:"https://m.media-amazon.com/images/I/91YKb63wdfS._AC_SY355_.jpg",
            sliderImage:{
                img1:'https://m.media-amazon.com/images/I/81N+kbbRLcS._AC_SY355_.jpg',
                img2:'https://m.media-amazon.com/images/I/916R20G6VTS._AC_SY355_.jpg',
                img3:'https://m.media-amazon.com/images/I/61Gr2Fzc0lS._AC_SY355_.jpg'
            },
            rating:{
                rate:3.9,
                count:120
               },
            amount:1,
            quprice:120
        },
       {
        id:2,
        title:"Mens Casual Premium Slim Fit T-Shirts ",
        price:500,
        description:"Slim-fitting style, contrast raglan long sleeve, three-button henley placket, light weight & soft fabric for breathable and comfortable wearing. And Solid stitched shirts with round neck made for durability and a great fit for casual fashion wear and diehard baseball fans. The Henley style round neckline includes a three-button placket.",
        category:"men",
        image:"https://m.media-amazon.com/images/I/415xRYxXTpL._AC_UX385_.jpg",
        sliderImage:{
           img1:'https://m.media-amazon.com/images/I/51qthrPO9BL._AC_UX385_.jpg',
           img2:'https://m.media-amazon.com/images/I/516pu+buKhL._AC_UX385_.jpg',
           img3:'https://m.media-amazon.com/images/I/319+wUUIUJL._AC_SR38,50_.jpg'  
        },
        rating:{
            rate:4.1,
            count:259
           },
        amount:1,
        quprice:500
    } ,
    {
        id:3,
        title:"Mens Cotton Jacket",
        price:55.99,
        description:"great outerwear jackets for Spring/Autumn/Winter, suitable for many occasions, such as working, hiking, camping, mountain/rock climbing, cycling, traveling or other outdoors. Good gift choice for you or your family member. A warm hearted love to Father, husband or son in this thanksgiving or Christmas Day.",
        category:"men",
        image:"https://m.media-amazon.com/images/I/91+C0dnunPL._AC_UF1000,1000_QL80_FMwebp_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/81QnBWv4PpS._AC_UF1000,1000_QL80_FMwebp_.jpg',
            img2:'https://m.media-amazon.com/images/I/71SkH7NJocL._AC_UF1000,1000_QL80_FMwebp_.jpg',
            img3:'https://m.media-amazon.com/images/I/81pQER5F5gS._AC_UF1000,1000_QL80_FMwebp_.jpg'
          
        },
        rating:{
            rate:4.7,
            count:500
            },
        amount:1,
        quprice:55.99
    },
    {
        id:4,
        title:"MBJ Women's Solid Short Sleeve Boat Neck V ",
        price:9.85,
        description:"95% RAYON 5% SPANDEX, Made in USA or Imported, Do Not Bleach, Lightweight fabric with great stretch for comfort, Ribbed on sleeves and neckline / Double stitching on bottom hem",
        category:"women",
        image:"https://m.media-amazon.com/images/I/81PCTOvDOeL._AC_UF1000,1000_QL80_FMwebp_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/81sdCP+qqCL._AC_UF1000,1000_QL80_FMwebp_.jpg',
            img2:'https://m.media-amazon.com/images/I/81LoAnDDp2L._AC_UF1000,1000_QL80_FMwebp_.jpg',
            img3:'https://m.media-amazon.com/images/I/61WVAdy7fML._AC_UF1000,1000_QL80_FMwebp_.jpg'
           
        },
        rating:{
            rate:4.7,
            count:130
            },
        amount:1,
        quprice:9.85
    },
    {
        id:5,
        title:"Opna Women's Short Sleeve Moisture",
        price:7.95,
        description:"100% Polyester, Machine wash, 100% cationic polyester interlock, Machine Wash & Pre Shrunk for a Great Fit, Lightweight, roomy and highly breathable with moisture wicking fabric which helps to keep moisture away, Soft Lightweight Fabric with comfortable V-neck collar and a slimmer fit, delivers a sleek, more feminine silhouette and Added Comfort",
        category:"women",
        image:"https://m.media-amazon.com/images/I/71zkNVvzuIL._AC_SX425_.jpg",
        sliderImage:{
         img1:'	https://m.media-amazon.com/images/I/615AeiN7GOL._AC_SX425_.jpg',
         img2:'	https://m.media-amazon.com/images/I/71Hj0ImjmPL._AC_SX425_.jpg',
         img3:'https://m.media-amazon.com/images/I/51+OO0jjbfL._AC_SX425_.jpg'
        
        },
        rating:{
            rate:4.5,
            count:146
            },
        amount:1,
        quprice:7.95
    },
    {
        id:6,
        title:"DANVOUY Womens T Shirt Casual Cotton Short",
        price:12.99,
        description:"95%Cotton,5%Spandex, Features: Casual, Short Sleeve, Letter Print,V-Neck,Fashion Tees, The fabric is soft and has some stretch., Occasion: Casual/Office/Beach/School/Home/Street. Season: Spring,Summer,Autumn,Winter.",
        category:"women",
        image:"https://m.media-amazon.com/images/I/71Zyg9yhBpL._AC_UY500_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/71bFBz2L4HL._AC_UY445_.jpg',
            img2:'https://m.media-amazon.com/images/I/7151Di3hB0L._AC_UX342_.jpg',
            img3:'https://m.media-amazon.com/images/I/61uBW-JktCL._AC_UX679_.jpg'
          
        },
        rating:{
            rate:3.6,
            count:145
            },
        amount:1,
        quprice:12.99
    },
    {
        id:7,
        title:"WD 2TB Elements Portable External Hard Drive - USB 3.0 ",
        price:64,
        description:"USB 3.0 and USB 2.0 Compatibility Fast data transfers Improve PC Performance High Capacity; Compatibility Formatted NTFS for Windows 10, Windows 8.1, Windows 7; Reformatting may be required for other operating systems; Compatibility may vary depending on user’s hardware configuration and operating system",
        category:"electronics",
        image:"https://fakestoreapi.com/img/61IBBVJvSDL._AC_SY879_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/51yOX-hmPqL._AC_SY450_.jpg',
            img2:'https://m.media-amazon.com/images/I/61t6Ng03JiL._AC_SY450_.jpg',
            img3:'https://m.media-amazon.com/images/I/51VL0K7T2SL._AC_SY450_.jpg'
           
        },
        rating:{
            rate:3.3,
            count:203
            },
        amount:1,
        quprice:64
    },
    {
        id:8,
        title:"SanDisk SSD PLUS 1TB Internal SSD - SATA III 6 Gb/s",
        price:109,
        description:"Easy upgrade for faster boot up, shutdown, application load and response (As compared to 5400 RPM SATA 2.5” hard drive; Based on published specifications and internal benchmarking tests using PCMark vantage scores) Boosts burst write performance, making it ideal for typical PC workloads The perfect balance of performance and reliability Read/write speeds of up to 535MB/s/450MB/s (Based on internal testing; Performance may vary depending upon drive capacity, host device, OS and application.)",category:"electronics",
        image:"https://fakestoreapi.com/img/61U7T1koQqL._AC_SX679_.jpg",
        sliderImage:{
           img1:'https://m.media-amazon.com/images/I/711vMT0N0BL._AC_SX679_.jpg',
           img2:'	https://m.media-amazon.com/images/I/71tpwWHXlOL._AC_SX679_.jpg',
           img3:'	https://m.media-amazon.com/images/I/71BfJwXt3bL._AC_SX679_.jpg'
        },
        rating:{
               rate:2.9,
               count:470
               },
        amount:1,
        quprice:109
    },
    {
        id:9,
        title:"Silicon Power 256GB SSD 3D NAND A55 SLC Cache Performance Boost SATA III 2.5",price:140,
        description:"3D NAND flash are applied to deliver high transfer speeds Remarkable transfer speeds that enable faster bootup and improved overall system performance. The advanced SLC Cache Technology allows performance boost and longer lifespan 7mm slim design suitable for Ultrabooks and Ultra-slim notebooks. Supports TRIM command, Garbage Collection technology, RAID, and ECC (Error Checking & Correction) to provide the optimized performance and enhanced reliability.",
        category:"electronics",
        image:"https://fakestoreapi.com/img/71kWymZ+c+L._AC_SX679_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/71DmBiZPOQL._AC_SY450_.jpg',
            img2:'https://m.media-amazon.com/images/I/61imrkJhaSL._AC_SY450_.jpg',
            img3:'	https://m.media-amazon.com/images/I/71fLPb5FKVL._AC_SY450_.jpg'
        },
        rating:{
               rate:4.8,
               count:319
               },
        amount:1,
        quprice:140
    },
    {
        id:10,
        title:"WD 4TB Gaming Drive Works with Playstation 4 Portable External Hard Drive",price:114,
        description:"Expand your PS4 gaming experience, Play anywhere Fast and easy, setup Sleek design with high capacity, 3-year manufacturer's limited warranty",category:"electronics",
        image:"https://m.media-amazon.com/images/I/91nz8ViqVLL._AC_SX425_.jpg",
        sliderImage:{
              img1:'https://m.media-amazon.com/images/I/61fVK-x2TtL._AC_SY355_.jpg',
              img2:'https://m.media-amazon.com/images/I/71Qj5rjgtgL._AC_SY355_.jpg',
              img3:'https://m.media-amazon.com/images/I/61eYV0J94zL._AC_SY355_.jpg'
        },
        rating:{
               rate:4.8,
               count:400
               },
        amount:1,
        quprice:114
    },
    { 
        id:11,
        title:"Acer SB220Q bi 21.5 inches Full HD (1920 x 1080) IPS Ultra-Thin",
        price:599,
        description:"21. 5 inches Full HD (1920 x 1080) widescreen IPS display And Radeon free Sync technology. No compatibility for VESA Mount Refresh Rate: 75Hz - Using HDMI port Zero-frame design | ultra-thin | 4ms response time | IPS panel Aspect ratio - 16: 9. Color Supported - 16. 7 million colors. Brightness - 250 nit Tilt angle -5 degree to 15 degree. Horizontal viewing angle-178 degree. Vertical viewing angle-178 degree 75 hertz",category:"monitor",
        image:"https://m.media-amazon.com/images/I/81QpkIctqPL._AC_SX679_.jpg",
        sliderImage:{
              img1:'https://m.media-amazon.com/images/I/71GbO41HbYL._AC_SX679_.jpg',
              img2:'https://m.media-amazon.com/images/I/71xb7GDuAGL._AC_SY450_.jpg',
              img3:'https://m.media-amazon.com/images/I/61zhZdddWVL._AC_SY450_.jpg'
        },
        rating:{
               rate:2.9,
               count:250
              },
        amount:1,
        quprice:599
    },
    { 
        id:12,
        title:"ASUS TUF Gaming VG27VH1B 27” Curved Monitor",
        price:12000,
        description:"Asus is most powerful laptop .Its the matherbod is also good . Its case pan most powerful and its lifetime warenty.I have a laptop of asus its serves me last 5 years now its ok.Its no need single service .i just only attech SSD .now its powerfull morethen 5 years ago.now i decide i buy a lapto and this a Asus",
        category:"monitor",
        image:"https://m.media-amazon.com/images/I/81i6G0uoctL._AC_SX679_.jpg",
        sliderImage:{
            img1:'https://m.media-amazon.com/images/I/816wB1hsaIL._AC_SY450_.jpg',
            img2:'https://m.media-amazon.com/images/I/81q2H6uDdRL._AC_SY450_.jpg',
            img3:'	https://m.media-amazon.com/images/I/718a1ruW5NL._AC_SY450_.jpg'
        },
        rating:{
               rate:2.9,
               count:250
              },
        amount:1,
        quprice:20000
    }
]

export default Dataex